import React from "react";

const UsrContext = React.createContext();
UsrContext.displayName = "UsrContext";

export default UsrContext;


// WEBPACK FOOTER //
// ./src/context/UsrContext.js